// JS for pages with a basic postable form
// Allows use of the form-helper webcomponent

import { FormHelper } from "./webcomponents/form-helper.js";
import { TrainInfoCard } from "./webcomponents/train-info-card.js";
import { WireupEmailPhoneWarning } from "./lib/form-utilities.js";

// Register required webcomponents
FormHelper.Register();
TrainInfoCard.Register();

WireupEmailPhoneWarning();

